module.exports = __webpack_public_path__ + "static/media/jochenB├╝hling.6a724984.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/authorSpotlight/jochenB├╝hling.jpg
// module id = 1265
// module chunks = 1